import * as actionTypes from './actionTypes';

export const addToolChooseCategorySuccess = (val) => {
  return {
    type: actionTypes.ADD_TOOL_CHOOSE_CATEGORY_SUCCESS,
    val: val
  }
}

export const toolInfoCompleted = (val) => {
  return {
    type: actionTypes.TOOL_INFO_COMPLETED,
    val: val
  }
}

export const toolFocusCompleted = (val) => {
  return {
    type: actionTypes.TOOL_FOCUS_COMPLETED,
    val: val
  }
}

export const toolLocationAndContactCompleted = (val) => {
  return {
    type: actionTypes.TOOL_LOCATION_AND_CONTACT_COMPLETED,
    val: val
  }
}

export const toolPrivacySettingsCompleted = (val) => {
  return {
    type: actionTypes.TOOL_PRIVACY_SETTINGS_COMPLETED,
    val: val
  }
}

export const toolGoBackPressed = (val) => {
  return {
    type: actionTypes.TOOL_GO_BACK_PRESSED,
    val: val
  }
}

export const addToolSuccess = (val) => {
  return {
    type: actionTypes.ADD_TOOL_SUCCESS,
    val: val
  }
}

export const editToolSuccess = (val) => {
  return {
    type: actionTypes.EDIT_TOOL_SUCCESS,
    val: val
  }
}

export const addToolBackToEdit = (val) => {
  return {
    type: actionTypes.ADD_TOOL_BACK_TO_EDIT,
    val: val
  }
}

export const editToolLoaded = (val) => {
  return {
    type: actionTypes.TOOL_LOADED,
    val: val
  }
}

export const leaveAddTool = () => {
  return {
    type: actionTypes.LEAVE_ADD_TOOL
  }
}

export const leaveEditTool = () => {
  return {
    type: actionTypes.LEAVE_EDIT_TOOL
  }
}

export const leavePreviewTool = () => {
  return {
    type: actionTypes.LEAVE_PREVIEW_TOOL
  }
}
